import React from "react";

import List from "@mui/material/List";
import Collapse from "@mui/material/Collapse";

import CustomListItem from "./CustomListItem";

import { getPathFromUrl } from "../../helper-functions/shared/pageUtils.js";
import { findCategoryParent, getCategoryByPath } from "../../helper-functions/shared/categoryUtils.js";

import * as Constants from "../../config/constants/Constants.js";

/**
 * Drop-down items component, used to create the different categories for the sidebar.
 *
 * Loops thought the categories array, creating a specific nested list for each.
 */
export default function CustomListDropdown(props) {
    const { categories } = props;

    const path = getPathFromUrl();
    const currentCategory = getCategoryByPath(path, false, categories);

    const minWidth = Constants.SIDEBAR_TEXT_MIN_WIDTH + 15;

    const [expanded, setExpanded] = React.useState(false);

    const handleClick = (panel) => (event) => {
        setExpanded(panel === expanded ? false : panel);
    };

    // Automatically open the correct category dropdown according to current path.
    // Otherwise, closes the dropdown.
    React.useEffect(() => {
        if (!path) return;

        if (!currentCategory) {
            setExpanded(false);
            return;
        }

        const parentCategory = findCategoryParent(currentCategory.id, categories);
        if (!parentCategory) return;

        setExpanded(currentCategoryInCategories() ? parentCategory.id : false);
    }, [path]);

    const currentCategoryInCategories = () => categories.some((cat) => cat?.categories && Object.values(cat.categories).some((subCat) => subCat.id === currentCategory.id));

    /**
     * Create the tooltip component, shown on the parent component.
     */
    const createTooltip = (category) => {
        return <CustomListItem {...props} category={category} handleClick={handleClick} expanded={expanded} enableExpand enableTooltip />;
    };

    /**
     * Create the subcategory list.
     */
    const createSublist = (category) => {
        const subcategories = Object.values(category.categories);
        const visibleSubcategories = subcategories.filter((subcategory) => (typeof subcategory.visible === "function" ? subcategory.visible(props) : subcategory.visible));

        return visibleSubcategories.map((item) => (
            <CustomListItem key={item.path} {...props} category={item} sx={{ minWidth, marginLeft: 1.5 }} path={category.path + item.path} enableNavigation enableTooltip />
        ));
    };

    return categories.map((category, index) => {
        // Skip rendering if the whole category is not visible
        if (category?.visible === false || (typeof category?.visible === "function" && !category?.visible(props))) {
            return null;
        }

        return (
            <List key={index} className="sidebar-parent" component="nav" aria-labelledby="nested-list-subheader" disablePadding>
                {createTooltip(category)}

                <Collapse in={expanded === category.id} className="sidebar-collapse" timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        {createSublist(category)}
                    </List>
                </Collapse>
            </List>
        );
    });
}
